import { render, staticRenderFns } from "./SwopVehicle.vue?vue&type=template&id=0aac010a&scoped=true"
import script from "./SwopVehicle.vue?vue&type=script&lang=js"
export * from "./SwopVehicle.vue?vue&type=script&lang=js"
import style0 from "./SwopVehicle.vue?vue&type=style&index=0&id=0aac010a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aac010a",
  null
  
)

export default component.exports